import store from "./services/store.js";
import axios from "axios";
import * as Sentry from "@sentry/vue";
export default {
  store,
  name: "App",

  created() {
    const newsJsonUrl = process.env.VUE_APP_NEWS_JSON_URL || "/news.json";
    axios.get(newsJsonUrl).then(response => {
      this.$store.dispatch("commitNews", response.data);
    }).catch(error => {
      console.log(error);
      Sentry.captureException(error);
    });
  },

  methods: {}
};